/**
 * IconSelector
 */
export class IconSelector {
  /**
   * @param {HTMLElement} elem
   * @param {Object} options
   */
  constructor(elem, options) {
    if (this.constructor === IconSelector) {
      throw new TypeError('Abstract class "AbstracIconSelectortConfig" cannot be instantiated directly');
    }

    this.elem = elem;
    this.$elem = $(elem);
    this.options = options;
    this.metadata = $(elem).data();
    this.colorpickerInput = $(elem).find('.is_color_preview').find('input');
    this.icons = [];
    this.iconsClass = '';
    this.iconsClassPrefix = '';
    this.sizes = [];
    this.rotations = [];
    this.metadataJsonFile = '';
    this._iconsMetadata = null;

    this.initialized = false;
  }

  /**
   * @private
   */
  _loadIconSet() {
    const iconsMetadata = this._getIconsMetadata();

    this.icons = [];

    for (const x in iconsMetadata.icons) {
      const id = iconsMetadata.icons[x].name;
      this.icons.push(`${this.iconsClassPrefix}-${id}`);
    }
  }

  /**
   * @return {string}
   * @private
   */
  _getIconsContainerLinks() {
    const iconsMetadata = this._getIconsMetadata();
    let links = '';

    for (const x in iconsMetadata.icons) {
      const id = iconsMetadata.icons[x].name;
      links += `<a href="#" title="${id}"><i class="${this.iconsClass} ${this.iconsClassPrefix}-${id}"></i>${id}</a>`;
    }

    return links;
  }

  /**
   * @return {Object}
   * @private
   */
  _getIconsMetadata() {
    if (this._iconsMetadata !== null) {
      return this._iconsMetadata;
    }

    // dynamically load metadata JSON file

    const response = $.ajax({
      url: this.metadataJsonFile,
      dataType: 'json',
      type: 'GET',
      async: false,
    });

    try {
      this._iconsMetadata = $.parseJSON(response.responseText);
    } catch (e) {
      throw new Error('error while loading font ' + this.constructor.name + ' metadata JSON file');
    }

    return this._iconsMetadata;
  }

  /**
   * @return {boolean}
   */
  init() {
    if (this.initialized) {
      console.warn('iconSelector already initialized !');
      return false;
    }

    this._loadIconSet();

    // @todo DOM templating
    // Dom elements
    this.switchInput = this.$elem.find('.form-switch').find('input');
    this.wrapper = this.$elem.find('.icons-selector-wrapper');
    this.fieldInput = this.$elem.find('.icons-selector-input');
    this.selectionInput = this.$elem.find('.icons-selector-selection');
    this.iconsContainer = this.$elem.find('.icons-selector-container');
    this.iconOptions = this.$elem.find('.icons-selector-options');
    this.rotationSelect = this.$elem.find('.icons-selector-rotations');
    this.sizeSelect = this.$elem.find('.icons-selector-sizes');

    this.iconsContainer.append(this._getIconsContainerLinks());

    // Buttons
    this.buttons = this.wrapper.find('a');

    this.buttons.on('click', (e) => {
      this.iconButtonClick($(e.currentTarget));
      e.preventDefault();
    });

    // Input
    this.fieldInput.attr('placeholder', this._getIconPlaceHolder()).on('keyup', (e) => {
      this.searchIcon();
    });

    let rotations = this.rotations;

    if (typeof this.options === 'object' && 'rotations' in this.options) {
      rotations = this.options.rotations;
    }

    this.rotationSelect.html('');
    rotations.forEach((rotation, i) => {
      this.rotationSelect.append(`<option value="${rotation.value}">${rotation.label}</option>`);
    });
    this.rotationSelect.on('change', (e) => {
      this.setRotation(this.rotationSelect.val());
    });
    this.rotationSelect.val('');

    let sizes = this.sizes;

    if (typeof this.options === 'object' && 'sizes' in this.options) {
      sizes = this.options.sizes;
    }

    this.sizeSelect.html('');
    sizes.forEach((size, i) => {
      this.sizeSelect.append(`<option value="${size.value}">${size.label}</option>`);
    });
    this.sizeSelect.on('change', (e) => {
      this.setSize(this.sizeSelect.val());
    });
    this.sizeSelect.val('');

    this.switchInput.on('change', (e) => {
      if (this.switchInput.prop('checked')) {
        this.wrapper.show();
      } else {
        this.wrapper.hide();
        this.buttons.removeClass('hide');
      }
    });

    this.switchInput.on('click', (e) => {
      if (this.switchInput.prop('checked')) {
        this.switchInput.focus();
      } else {
        this.fieldInput.val('');
      }
    });

    // Initial values

    const rotationInitialValue = this.rotationSelect.attr('data-initial-value');
    if (rotationInitialValue !== undefined && rotationInitialValue !== false) {
      this.rotationSelect.val(rotationInitialValue).change();
    }
    const sizeInitialValue = this.sizeSelect.attr('data-initial-value');
    if (sizeInitialValue !== undefined && sizeInitialValue !== false) {
      this.sizeSelect.val(sizeInitialValue).change();
    }

    this.changeValues();

    this.switchInput.change();

    this.initialized = true;

    return true;
  }

  /**
   * Search mathing icon using regex.
   */
  searchIcon() {
    const regex = new RegExp(`${this.fieldInput.val().trim()}`, 'i');
    let nbResults = 0;

    this.buttons.each((index, element) => {
      const classes = $(element).find('i').attr('class').replace(this.iconsClass, '').trim();
      $(element).toggleClass('hide', !regex.test(classes));
      nbResults += regex.test(classes) ? 1 : 0;
    });

    this.iconsContainer.toggleClass('hide', nbResults === 0);
    this.iconOptions.toggleClass('hide', nbResults === 0);
  }

  /**
   * Search matching icon and update current icon value.
   */
  changeValues() {
    if (this.fieldInput.val() != '') {
      this.searchIcon();
      this.iconsContainer.find(
        'a[title="' + this.fieldInput.val().replace(this.iconsClassPrefix + '-', '') + '"]',
      ).addClass('active');
      this.switchInput.prop('checked', true).change();
    }
  }

  /**
   * @return {string}
   * @private
   */
  _getIconPlaceHolder() {
    return `${this.iconsClassPrefix}-home`;
  }

  /**
   * @param {external:jQuery} $button
   */
  iconButtonClick($button) {
    $button.addClass('active').siblings().removeClass('active');
    const icon = $button.find('i').attr('class').replace(this.iconsClass, '').trim();
    const classes = this._clean('icons');
    this.fieldInput.val(icon);
    this.selectionInput.val(`${icon}${classes != '' ? ' ' + classes : ''}`);

    this.$elem.trigger('on.icon.change', [this.selectionInput.val()]);
  }

  /**
   * @param {string|null} icon
   * @return {IconSelector}
   */
  setIcon(icon) {
    if (icon === null) {
      icon = '';
    }

    const classes = this._clean('icons');

    this.fieldInput.val(icon);

    this.selectionInput.val(`${icon}${classes != '' ? ' ' + classes : ''}`);

    this.iconsContainer.find('a').removeClass('active');

    this.iconsContainer
      .find('a[title="' + icon.replace(this.iconsClassPrefix + '-', '') + '"]')
      .addClass('active');

    this.searchIcon();

    this.$elem.trigger('on.icon.change', [this.selectionInput.val()]);

    return this;
  }

  /**
   * @param {Number|null} rotation
   * @return {IconSelector}
   */
  setRotation(rotation) {
    if (rotation === 0 || rotation === null) {
      rotation = '';
    }

    this.rotationSelect.val(rotation);

    const classes = this._clean('rotations');
    this.selectionInput.val(`${classes}${rotation != '' ? ' ' + rotation : ''}`);

    this.$elem.trigger('on.icon.change', [this.selectionInput.val()]);

    return this;
  }

  /**
   * @param {Number} size
   * @return {IconSelector}
   */
  setSize(size) {
    if (size === 100) {
      size = '';
    }

    this.sizeSelect.val(size);

    const classes = this._clean('sizes');
    this.selectionInput.val(`${classes}${size != '' ? ' ' + size : ''}`);

    this.$elem.trigger('on.icon.change', [this.selectionInput.val()]);

    return this;
  }

  /**
   * @param {string} color
   * @return {IconSelector}
   */
  setColor(color) {
    this.colorpickerInput.val(color);
    this.colorpickerInput.spectrum('set', color);

    return this;
  }

  /**
   * @param {string} option
   * @return {string}
   * @private
   */
  _clean(option) {
    // get applied classes
    const classes = this.selectionInput.val().split(' ');

    // remove options
    this[option].forEach((optionName) => {
      const index = classes.indexOf(optionName);
      if (index > -1) {
        classes.splice(index, 1);
      }
    });

    return classes.join(' ').trim();
  }
}
